module.exports = __webpack_public_path__ + "static/media/Eten.8468a545.png";